export const LOGO_URL = "/logo.svg";

export const DOODLE_BG = "/chat-doodle.svg";

export const DEMO_KEY = "sc_demo_key_superchat";

export const BRAND = {
  teal: "#0e8f7e",
  green: "#22c55e",
  ink: "#111b18",
};
